import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sb-comp-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
  standalone: false,
})
export class CompanyInfoComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
